export default __webpack_public_path__ + "static/media/013-boat.8ae2d5e8.svg";